// Path: ./src/hooks/useStoreTagOptions.ts
import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfStoreTag } from "@swagger/typescript-fetch-goflyer";

export const useStoreTagOptions = () => {
  const [storeTagOptionList, setStoreTagOptionList] = useState<GfStoreTag[]>();

  const fetchStoreTags = useCallback(async () => {
    try {
      const storeTagData =
        await adminApiService.getManyBaseGfStoreTagAdminControllerGfStoreTag();

      setStoreTagOptionList(storeTagData.data);
    } catch (error) {
      console.error("Error fetching store tags:", error);
    }
  }, []);

  useEffect(() => {
    fetchStoreTags();
  }, []);

  return { storeTagOptionList, fetchStoreTags };
};
